import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import NewsList from "../../features/news/NewsList";
import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import SearchBar from "../../components/SearchBar";
import { ENUM_ROUTES } from "../../RoutesEnum";
import { showError } from "../../constants/toasts";
import { useLazyGetNewsQuery } from "../../services/news";
import { isValidInput } from "../../utils/validations";
import { NewsApiResponse } from "../../types/General";
import { useLazyGetBlogQuery } from "../../services/blogs";
import BlogList from "../../features/manageBlogs/BlogsList";

const ManageBlogs = () => {
  const navigate = useNavigate();
  const [getBlog] = useLazyGetBlogQuery();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [NewsData, setNewsData] = useState<NewsApiResponse[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchBlogs = async () => {
    try {
      const response = await getBlog({
        from: page,
        size: pageSize,
        search: searchTerm,
      }).unwrap();

      if (response?.statusCode === 200) {
        setNewsData(response.data.data || []);
        setTotalCount(response.data.total || 0);
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to fetch Blogs");
    }
  };
  useEffect(() => {
    fetchBlogs();
  }, [searchTerm, page, pageSize]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Blog</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Blog
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate(ENUM_ROUTES.ADD_BLOG)}
            >
              <AddIcon /> Add
            </Button>
            {/* <Button className="btn btn_grey">
              <DownloadIcon /> Export
            </Button> */}
          </div>
        </div>
        <BlogList NewsData={NewsData} fetchNews={fetchBlogs} />
      </div>
    </MainContainer>
  );
};

export default ManageBlogs;
